import { useMemo } from "react";

import type { MapProvider } from "@jti/fe-common";
import type { FlotiqStore } from "@jti/fe-common/types";

import { getNaverDirectionUrl } from "../../utils";
import { GOOGLE_DIRECTION_URL_CONST } from "../useGoogleMapsStoreLocator/useGoogleMapsStoreLocator";
import { getYandexDirectionUrl } from "../useYandexMapsStoreLocator/utils";

type UseDirectionURLProps = {
  store: FlotiqStore;
  locationServiceMapProvider: MapProvider;
};

export const useDirectionURL = ({ store, locationServiceMapProvider }: UseDirectionURLProps): string => {
  return useMemo(() => {
    if (!store.Location?.lat || !store.Location?.lon) return "";

    switch (locationServiceMapProvider) {
      case "google":
        return `${GOOGLE_DIRECTION_URL_CONST}${store.Location.lat},${store.Location.lon}`;
      case "naver":
        return getNaverDirectionUrl(store.ExternalId);
      case "yandex":
        return getYandexDirectionUrl(store);
      default:
        return "";
    }
  }, [store.Location?.lat, store.Location?.lon, store.ExternalId, locationServiceMapProvider]);
};
